// src/components/Home.js
import React from 'react';
import Account from "../components/Navbar";
import EditProduct from "../components/ProductManagememt/EditProduct";

const EditProductPage = () => {
	return (
		<EditProduct/>
	)
}

export default EditProductPage;